export const TABS = {
  CREATE: 'create',
  UPLOAD: 'upload'
};

export const TEMPLATE_URL = {
  EXERCISE: '/templates/exercises.xls'
};
